<div class="row column {{ wrapperClass }}" *ngIf="!hide || this.showBackButton() === true">
	<ol *ngIf="showBackButton() === false">
		<li *ngFor="let step of menu; let stepIndex = index" [class]="getClass(step)" (click)="changeStep(step)">
			<span class="counter">{{ stepIndex + 1 }}</span>
			<span class="name" [innerHTML]="getText(step)"></span>
			<small [innerHTML]="getAdditionalText(step)"></small>
		</li>
	</ol>

	<button *ngIf="showBackButton() === true" class="button arrow-left" (click)="forceChangeStep(backbuttonSteps[step])">{{ 'stepnavigation.back' | translate }}</button>
</div>
